import { render } from "./MemberNavbar.vue?vue&type=template&id=a57cfb18"
import script from "./MemberNavbar.vue?vue&type=script&lang=js"
export * from "./MemberNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__